import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';

import * as S from './styles';
import Label from '../Label';

const SelectField = forwardRef(
  (
    {
      options,
      handleChange,
      onBlur,
      labelText,
      labelPadding,
      hasLabelMargin,
      hasLabel,
      placeholderText,
      value,
      isDisabled,
      name,
      width,
      hasSecondaryStyle,
      isMulti,
      isClearable,
      defaultValue,
      menuPlacement,
    },
    ref,
  ) => (
    <S.Container>
      {hasLabel && (
        <Label
          text={labelText}
          htmlFor={name}
          hasMargin={hasLabelMargin}
          pd={labelPadding}
        />
      )}
      <S.Select
        noOptionsMessage={() => 'Opção não encontrada'}
        ref={ref}
        inputProps={{ id: { name } }}
        options={options}
        placeholder={placeholderText}
        value={value}
        onChange={handleChange}
        onBlur={onBlur}
        width={width}
        hasSecondaryStyle={hasSecondaryStyle}
        isMulti={isMulti}
        defaultValue={defaultValue}
        menuPlacement={menuPlacement}
        isDisabled={isDisabled}
        isClearable={isClearable}
        // isOptionDisabled={option => (option.disabled === isDisabled)}
        // isLoading={isDisabled}
      />
    </S.Container>
  ),
);

export default SelectField;

SelectField.defaultProps = {
  onBlur: e => e,
  isDisabled: false,
  value: '',
  placeholderText: 'Selecione...',
  defaultValue: {
    value: undefined,
    label: '',
  },
  width: 100,
  hasSecondaryStyle: false,
  isMulti: false,
  isClearable: false,
  menuPlacement: 'bottom',
  hasLabel: true,
  hasLabelMargin: false,
  labelPadding: 0,
};

SelectField.propTypes = {
  defaultValue: PropTypes.shape({
    value: PropTypes.number,
    label: PropTypes.string,
    labelPadding: 0,
  }),
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      label: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    }),
  ).isRequired,
  isDisabled: PropTypes.bool,
  labelText: PropTypes.string.isRequired,
  handleChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func,
  placeholderText: PropTypes.string,
  // eslint-disable-next-line react/forbid-prop-types
  value: PropTypes.any,
  name: PropTypes.string.isRequired,
  width: PropTypes.number,
  hasSecondaryStyle: PropTypes.bool,
  isMulti: PropTypes.bool,
  isClearable: PropTypes.bool,
  menuPlacement: PropTypes.string,
  hasLabel: PropTypes.bool,
  labelPadding: PropTypes.number,
  hasLabelMargin: PropTypes.bool,
};
